import {Injectable, OnInit} from '@angular/core';
import { AuthServerProvider } from '..';

@Injectable()
export class PermissionService {

    private _permissions: any

    constructor(
        private authProvider: AuthServerProvider,
    ) {
        this.setPermissions()
    }

    private setPermissions() {
        if (this.authProvider.getInfo() && this.authProvider.getInfo().role) {
            const userPermissions = this.authProvider.getInfo().role.permission

            this._permissions = {};
            userPermissions.forEach((screenName) => {
                this._permissions[screenName] = true
            });
        }
    }

    checkPerm(permission: string): boolean{
        if (!this._permissions)
            return false
        return this._permissions[permission] === true
    }

    checkOrPerms(...permissions: string[]): boolean {
        for (var i = 0; i < permissions.length; i ++){
            if (this.checkPerm(permissions[i])){
                return true;
            }
        }
        return false;
    }

    checkAndPerms(...permissions: string[]): boolean {
        for (var i = 0; i < permissions.length; i ++){
            if (!this.checkPerm(permissions[i])){
                return false;
            }
        }
        return true;
    }

    permissions(){
        return this._permissions
    }
}
